import { API } from "@swivl-mono/api-helper";
import { GroupInterface, LocationInterface, LocationScope, LocationsMatrix } from "@swivl-mono/types";

export class LocationMatrixHelper {
  static updateMatrix(
    enabled: boolean,
    locationType: LocationScope,
    itemId: number,
    initialLocations: LocationsMatrix,
    groups: GroupInterface[],
  ): LocationsMatrix {
    let locations = { ...initialLocations };

    if (locationType === "org") {
      if (enabled) {
        locations = { orgId: itemId };
      } else {
        locations = {};
      }

      return locations;
    }

    if (locationType === "group") {
      if (enabled) {
        if (!locations.groupIds) {
          locations.groupIds = [];
        }
        if (!locations.groupIds.includes(itemId)) {
          locations.groupIds.push(itemId);
        }
      } else {
        if (locations.orgId) {
          // if org id is on, turn groups on for the others instead
          delete locations.orgId;
          locations.groupIds = groups.map((group) => group.id);
        }
        if (locations.groupIds) {
          // if group id is on, turn off this group
          locations.groupIds = locations.groupIds.filter((id: number) => id !== itemId);
        }
      }

      // REMOVE ALL LOCATIONS THAT ARE PART OF THIS GROUP!
      if (locations.locationIds) {
        let group = groups.find((group) => group.id === itemId);
        if (group) {
          group.locations.forEach((location) => {
            locations.locationIds = locations.locationIds?.filter((id: number) => id !== location.id);
          });
        }
      }

      return cleanupScope(locations);
    }

    if (locationType === "location") {
      if (enabled) {
        if (!locations.locationIds) {
          locations.locationIds = [];
        }
        if (!locations.locationIds.includes(itemId)) {
          locations.locationIds.push(itemId);
        }
      } else {
        // IF org id is on, turn groups on for the others instead
        if (locations.orgId) {
          delete locations.orgId;
          locations.groupIds = groups.map((group) => group.id);
        }
        // Disable group if enabled
        const group = groups.find((group) => group.locations.find((location) => location.id === itemId));

        if (group && locations.groupIds && locations.groupIds.includes(group.id)) {
          // Group exists and is enabled so we will turn off this location, and leave on all others in the group.

          // Make sure locationIds exists.
          if (!locations.locationIds) {
            locations.locationIds = [];
          }
          // remove this location if it is in the locationIds
          if (locations.locationIds.includes(itemId)) {
            locations.locationIds = locations.locationIds.filter((id: number) => id !== itemId);
          }
          // Turn on all other locations in that group.
          for (const location of group.locations) {
            if (itemId !== location.id && !locations.locationIds.includes(location.id)) {
              locations.locationIds.push(location.id);
            }
          }
          // disable group id
          locations.groupIds = locations.groupIds.filter((id: number) => id !== group.id);
        } else {
          if (locations.locationIds) {
            locations.locationIds = locations.locationIds.filter((id: number) => id !== itemId);
          }
        }
      }

      return cleanupScope(locations);
    }

    return cleanupScope(initialLocations);
  }

  static isLocationInMatrix(location: LocationInterface, matrix: LocationsMatrix) {
    if (matrix.orgId) {
      return true;
    }
    if (matrix.groupIds) {
      if (location.groupId && matrix.groupIds.includes(location.groupId)) {
        return true;
      }
    }
    if (matrix.locationIds) {
      if (matrix.locationIds.includes(location.id)) {
        return true;
      }
    }
    return false;
  }

  static async allLocationsForMatrix(matrix: LocationsMatrix, groups: GroupInterface[]) {
    let locations: LocationInterface[] = [];
    for (const group of groups) {
      for (const location of group.locations) {
        if (LocationMatrixHelper.isLocationInMatrix(location, matrix)) {
          locations.push(location);
        }
      }
    }
    return locations;
  }
}

function cleanupScope(locations: LocationsMatrix): LocationsMatrix {
  if (locations.groupIds && locations.groupIds.length === 0) {
    delete locations.groupIds;
  }
  if (locations.locationIds && locations.locationIds.length === 0) {
    delete locations.locationIds;
  }

  // if ( locations.locationIds?.length || locations.groupIds?.length) {
  //   delete locations.orgId;
  // }
  return locations;
}
